<template>
  <div class="footer">
    <div class="footer-main">
      <div class="providers-title">{{ $t('footer.providers') }}</div>
      <div class="friend-img"></div>
      <div class="brandShow">
        <div class="mian-list">
        <div class="left_about">
          <h4  class="title">{{$t('footer.About1CRIC')}}</h4>
            <p><font style="color:#ebb525"> 1CRIC</font> is the Best Cricket Betting, Online Casinoand Entertainment Game App in India. Asidefrom being the best cricket betting app, wealso offer variety of casino games likeBaccarat, Roulette, Teen Patti, Andar Bahar, SicBo and more with professional live dealers.</p>
            <p><font style="color:#ebb525"> 1CRIC</font> is the Best Cricket Betting, Online Casinoand Entertainment Game App in India. Asidefrom being the best cricket betting app, wealso offer variety of casino games likeBaccarat, Roulette, Teen Patti, Andar Bahar, SicBo and more with professional live dealers.</p>
            <p>We offers the best variety of promotions andunlimited cash back. You can receive generoussign up bonus and there's NO Deposit required</p>
        </div>
        <div class="center_info">
          <div class="sefullinks">
            <h4 class="title">{{$t('footer.INFORMATION')}} </h4>
            <ul class="footer-link-list">
              <li v-for="(item,index) in downNav" :key="index" @click="gotop" >
                <router-link :to="{path: '/helpCenter/startUse',query: {id: item.id}}">
                  {{item.name}}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
          <div class="customer-Support">
            <h4 class="title">{{ $t('footer.about') }} </h4>
             <ul class="footer-link-list">
              <li v-for="(item,index) in footerNav" :key="index" @click="handleGoPage(item)">
                {{$t(item.name)}}
              </li>
            </ul>
            <img src="./img/logo.jpg" />
          </div> 
        </div>
      </div>
      <div class="tools">
        <h4 class="title">{{ $t('footer.payment') }} </h4>
        <ol>
          <li v-for="item in fixedTextList" :key="item.index">
            <img :src="item.icon" alt width="auto" height="auto"/>
          </li>
        </ol>
      </div>
      <div class="copyright">
        <span><img src="./img/18plus.png" alt /></span>
        <span style="-webkit-text-stroke:.3px;">{{ $t("footer.copyBrand")}}</span>
      </div>
    </div>
    <!-- 下载弹窗 -->
    <appDownload ref="appdown"/>
  </div>
</template>

<script>
  import appDownload from "../common/appDownload.vue";
  import { fixedTextList,footerNav,topNavList} from '../utils/Data.js'
  import { mapState, mapMutations,mapActions} from 'vuex'
  import { common,commonApi } from '@/common/index'
  export default {
    data() {
      return {
        footerNav,
        fixedTextList,
        topNavList,
        curIndex: 0,
        value: '',
        yhPcLiveChatList:'',
        yhPcWhatsappList:'',
      }
    },
    components: { appDownload },
    computed: {
      ...mapState({
        customer_service_system_link: state => state.FrontConfigList.customer_service_system_link,
        downNav: state => state.downNav,
        customer_service_QQ: state => state.FrontConfigList.customer_service_QQ,
        contact_email: state => state.FrontConfigList.contact_email,
        agent_url: (state) =>state.FrontConfigList.agent_url,    //代理链接
        live_chat: state => state.FrontConfigList.live_chat,
        whatsapp: state => state.FrontConfigList.whatsapp,
        appDownload: state => state.linkList.appDownload,
      }),
    },
    methods: {
      handleGoRegister(login){
        if(!login){ this.$router.push({ path:'/register' }) }
      },
      handleGoPage({ url }){ return this.$router.push({ path:url }) },
      handleGODown(){  // ios android 下载
        // window.open(this.appDownload)
        this.$refs.appdown.dialogDown = !this.$refs.appdown.dialogDown
      },
      gotop(){
        document.getElementById("app").scrollTop = 0;
      },
      fetchImg() {
        let imgCodes = ['pcLiveChat','pcWhatsApp'].join(',')
        commonApi.HOMEBEFORE.fetchImgs(imgCodes)
        .then((data)=>{
          this.yhPcLiveChatList = data.pcLiveChat;
          this.yhPcWhatsappList = data.pcWhatsApp;
        })
      },
      ...mapActions(['getArticleType']),
      // ...mapMutations(["setshowloginfloat",]),
    },
    mounted() {
      this.getArticleType()
      this.fetchImg()
    }
  }
</script>

<style scoped lang="scss">
@import '../../style/mixins';
  .footer {
    width:100%;
    .footer-main{
      color: #000;
      padding-top: 60px;
      width: 1160px;
      margin: 0 auto;
      .providers-title{
        color: #e8ab06;
        text-align: center;
        font-size: 40px;
        font-weight: bolder;
        margin-bottom: 40px;
      }
      .friend-img{
         background:url('./img/hezuohuoban.jpg') no-repeat top center;
         width: 1100px;
         height: 158px;
         margin: 0 auto;
      }
      .title{
        padding:26px 0;
        font-weight: 500; 
        font-size: 30px;
        color: #000;
      }
      .brandShow{
        color: #000;
        margin-top:40px;
        .mian-list{
          display: flex;
          justify-content:space-between;
          font-family: Roboto-Regular;
          font-size: 14px;
          .left_about{
            width:500px;
            padding-right: 30px;
            p{margin-bottom: 8px; font-family: ArialMT; font-size: 16px;}

            &.quicklinks{ width:36%;span{line-height:28px}}
          }
          .center_info{
            width: 260px;
          }
            .footer-link-list li{
              cursor: pointer;
              font-family: ArialMT;
              font-size: 18px;
              color: #000;
              padding-bottom:12px;
              a{ color: #000;}
            }
        }

      }
      .tools{
        margin-top:28px;
        padding:22px 0%;
        border-bottom:1px solid #e0e0e0;
        text-align: left;
        li{ 
          margin-right:39px;
          cursor: pointer;
          display:inline-block;
        }
      }
    
      .copyright{
        text-align: center;
        padding:33px 0 28px;
        font-family: Roboto-Regular;
        font-size: 14px;
        color: #666;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/build901/components/footer/footer.vue